<div class="half-donut-card">
  <span class="text">{{ text }}</span>
  <div class="chart-box">
    <canvas baseChart [type]="doughnutChartType" [data]="doughnutChartData" [options]="doughnutChartOptions">
    </canvas>

    <div class="center-label">
      <span class="value">{{ displayValue }}%</span>
    </div>
  </div>
</div>